import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

const routes: Routes = [
  {
    path: 'category',
    loadChildren: () =>
      import('./template/template.module').then((m) => m.TemplateModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'homepage',
    loadChildren: () =>
      import('./homepage/homepage.module').then((m) => m.HomepageModule),
  },
  {
    path: 'deduplication',
    loadChildren: () =>
      import('./deduplication/deduplication.module').then(
        (m) => m.DeduplicationModule
      ),
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'spam-reports',
    loadChildren: () =>
      import('./spam-reports/spam-reports.module').then(
        (m) => m.SpamReportsModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'election-details',
    loadChildren: () =>
      import('./election-details/election-details.module').then(
        (m) => m.ElectionDetailsModule
      ),
  },
  {
    path: 'verify-profiles',
    loadChildren: () =>
      import('./verify-profile/verify-profile.module').then(
        (m) => m.VerifyProfileModule
      ),
  },
  {
    path: 'claim-request',
    loadChildren: () =>
      import('./claim-request/claim-request.module').then(
        (m) => m.ClaimRequestModule
      ),
  },
  {
  path: 'dashboard',
  loadChildren: () =>
    import('./dashboard/dashboard.module').then(
      (m) => m.DashboardModule
    ),
},
  {
    path: 'matching-profile',
    loadChildren: () =>
      import('./matching-profile/matching-profile.module').then(
        (m) => m.MatchingProfileModule
      ),
  },
  {
    path: 'view-user-profile/:profileId',
    loadChildren: () =>
      import('./view-user-profile/view-user-profile.module').then(
        (m) => m.ViewUserProfileModule
      ),
  },
  {
    path: 'claim-profile/:profileId',
    loadChildren: () =>
      import('./claim-profile/claim-profile.module').then(
        (m) => m.ClaimProfileModule
      ),
  },
  {
    path: '',
    redirectTo: 'landing-page',
    pathMatch: 'full',
  },
  {
    path: 'report-abuse',
    loadChildren: () =>
      import('./report-abuse/report-abuse.module').then(
        (m) => m.ReportAbuseModule
      ),
  },
  {
    path: 'landing-page',
    loadChildren: () =>
      import('./landing-page/landing-page.module').then(
        (m) => m.LandingPageModule
      ),
  },
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  // ✅ Removed PreloadAllModules
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
